// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f011a72","453":"277fc438","455":"ca0d1bf7"}[chunkId] + ".chunk.js";
};